enum TabState {
    Hide = 0,
    ReadOnly = 1,
    Edit = 2
}

export {
    TabState
}